import React from "react";
import { Box } from "@mui/material";
import LinkedIn from "../../../components/PreviewSocial/LinkedIn";
import Twitter from "../../../components/PreviewSocial/Twitter";
import Telegram from "../../../components/PreviewSocial/Telegram";
import Facebook from "../../../components/PreviewSocial/Facebook";
import Reddit from "../../../components/PreviewSocial/Reddit";
import Tiktok from "../../../components/PreviewSocial/TikTok";
import Instagram from "../../../components/PreviewSocial/Instagram";
import Youtube from "../../../components/PreviewSocial/Youtube";
import Threads from "../../../components/PreviewSocial/Threads";
import { ReactComponent as EmptyPosts } from "../../../images/No posts.svg";
import ImageError from "../../../components/ImageError";
import _request from "actions/_request";
import { THUMB_SIZE } from "actions/_request/Files";
import { SOCIAL_TYPES } from "../constants";

// Parts 2..N of a Threads chain for the preview: empty parts are skipped, media become preview thumbnails like
// part 1's `selectedImages`.
const toThreadsPreviewReplies = (parts) =>
  (Array.isArray(parts) ? parts : [])
    .filter((p) => p && ((p.text || "").trim() || (p.files || []).length > 0))
    .map((p, i) => ({
      key: p.key || `reply-${i}`,
      text: p.text || "",
      images: (p.files || []).map((id, j) => (
        <ImageError
          key={j}
          src={_request.files.formLink(id, true, THUMB_SIZE.PREVIEW)}
          style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "10px" }}
        />
      )),
    }));

const SocialPreview = ({
  selectedPreviewAccountId,
  selectedAccounts,
  accounts,
  formattedTags,
  selectedImages,
  selectedIndex,
  postTitle,
  postText,
  youtubePrivacy,
  youtubeCategoryId,
  telegramInlineKeyboard,
  instagramPostType,
  threadsReplies,
  tr,
}) => {
  const selectAccount =
    selectedPreviewAccountId && selectedAccounts.includes(selectedPreviewAccountId)
      ? accounts.find((acc) => acc && acc.id === selectedPreviewAccountId)
      : accounts.find((acc) => acc && selectedAccounts.includes(acc.id));
  const socialType = selectAccount ? selectAccount.social_type : "";

  const previewComponents = {
    [SOCIAL_TYPES.LINKEDIN]: LinkedIn,
    [SOCIAL_TYPES.INSTAGRAM]: Instagram,
    [SOCIAL_TYPES.FACEBOOK]: Facebook,
    [SOCIAL_TYPES.TELEGRAM]: Telegram,
    [SOCIAL_TYPES.TWITTER]: Twitter,
    [SOCIAL_TYPES.TIKTOK]: Tiktok,
    [SOCIAL_TYPES.REDDIT]: Reddit,
    [SOCIAL_TYPES.YOUTUBE]: Youtube,
    [SOCIAL_TYPES.THREADS]: Threads,
  };

  const PreviewComponent = previewComponents[socialType];

  if (!PreviewComponent) {
    return (
      <Box
        className="post-preview-container"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "300px",
          textAlign: "center",
        }}>
        <Box
          className="post-preview-text"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            marginBottom: "20px",
          }}>
          {tr("postPage.selectPlatformPreview")}
        </Box>
        <EmptyPosts />
      </Box>
    );
  }

  const extraProps =
    socialType === SOCIAL_TYPES.YOUTUBE
      ? { youtubePrivacy, youtubeCategoryId }
      : socialType === SOCIAL_TYPES.TELEGRAM
      ? { inlineKeyboard: telegramInlineKeyboard }
      : socialType === SOCIAL_TYPES.INSTAGRAM
      ? { postType: instagramPostType || "feed" }
      : socialType === SOCIAL_TYPES.THREADS
      ? { replies: toThreadsPreviewReplies(threadsReplies) }
      : {};

  return (
    <PreviewComponent
      selectedAccounts={selectedAccounts}
      formattedTags={formattedTags}
      accResp={accounts}
      selectedImages={selectedImages}
      selectedIndex={selectedIndex}
      avatars={accounts.map((it) => it.avatar)}
      postTitle={postTitle}
      postText={postText}
      {...extraProps}
    />
  );
};

export default SocialPreview;
